import { arrayToRecord } from '@ipfabric/utils/fp/arrayToRecord';
import { prop } from '@ipfabric/utils/fp/prop';
import { sort } from 'ramda';
import type React from 'react';

const exceptionsTypesTranslations = [
  { value: 'ABAmbiguousCommand', label: 'Ambiguous or Incomplete command' },
  {
    value: 'ABCmdAuthFail',
    label: 'Command authorization failure',
    fixOnSite: true,
  },
  { value: 'ABCommandFailedReport', label: 'Invalid command' },
  { value: 'ABCommandTimeout', label: 'Command timeout' },
  {
    value: 'ABCustomDiscoveryError',
    label: 'Custom Discovery Data definition failure',
  },
  { value: 'ABConnectionError', label: 'Connection error' },
  { value: 'ABFatalError', label: 'Fatal error' },
  { value: 'ABMapResultError', label: 'Command result mapping failure' },
  { value: 'ABNoCommand', label: 'Unspecified command' },
  { value: 'ABNoConfig', label: 'Unknown device version' },
  { value: 'ABUnsupportedDevice', label: 'Unsupported device' },
  {
    value: 'ABNoCredentials',
    label: 'No credentials provided',
    fixOnSite: true,
  },
  { value: 'ABParseError', label: 'Parsing command failure' },
  {
    value: 'ABParseBadConfigError',
    label: 'Possible device issue (during parsing)',
  },
  {
    value: 'ABMapResultBadConfigError',
    label: 'Possible device issue (during command mapping)',
  },
  { value: 'ABTaskMapResultError', label: 'Task result mapping failure' },
  {
    value: 'ABTaskMapResultBadConfigError',
    label: 'Possible device issue (during task mapping)',
  },
  {
    value: 'ABCommandExecPrevented',
    label: 'Command not executed for prevented reasons',
  },
  {
    value: 'ABWorkerAuthError',
    label: 'Authentication error',
    fixOnSite: true,
  },
  {
    value: 'SummaryABMapResultError',
    label: 'Result mapping failures (per command)',
  },
  { value: 'SummaryABParseError', label: 'Parsing failures (per command)' },
  {
    value: 'SummaryABTaskMapResultError',
    label: 'Result mapping failures (per task)',
  },
  { value: 'ABRequestFailed', label: 'Request failed' },
];

export const exceptionsTypes = sort(
  ({ label: a }, { label: b }) => a.localeCompare(b),
  exceptionsTypesTranslations,
);
export const exceptionsTypesByKey = arrayToRecord(
  prop('value' as never),
  prop('label' as never),
)(exceptionsTypes);

export default {
  en: {
    ...exceptionsTypes.reduce<{ [key: string]: React.ReactNode }>(
      (acc, err) => {
        acc[err.value] = err.fixOnSite ? (
          <span key={err.value}>
            <strong>{err.label}</strong>
          </span>
        ) : (
          err.label
        );
        return acc;
      },
      {},
    ),
  },
};
